import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  JSON: any,
  DateTime: any,
};

export type Analytics = {
   __typename?: 'Analytics',
  id: Scalars['String'],
  pageviews?: Maybe<Scalars['Int']>,
  postRank?: Maybe<Scalars['Int']>,
};

export type AnalyticsOrderByInput = {
  id?: Maybe<SortOrder>,
  pageviews?: Maybe<SortOrder>,
  postRank?: Maybe<SortOrder>,
};

export type AnalyticsWhereInput = {
  AND?: Maybe<Array<AnalyticsWhereInput>>,
  OR?: Maybe<Array<AnalyticsWhereInput>>,
  NOT?: Maybe<Array<AnalyticsWhereInput>>,
  id?: Maybe<StringFilter>,
  pageviews?: Maybe<IntNullableFilter>,
  postRank?: Maybe<IntNullableFilter>,
  Post?: Maybe<PostListRelationFilter>,
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>,
  not?: Maybe<NestedBoolFilter>,
};

export type BoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>,
  not?: Maybe<NestedBoolNullableFilter>,
};

export type Category = {
   __typename?: 'Category',
  id: Scalars['String'],
  categoryId: Scalars['String'],
  posts: Array<Post>,
  site: Site,
  count?: Maybe<Scalars['Int']>,
  description?: Maybe<Scalars['String']>,
  link?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  slug?: Maybe<Scalars['String']>,
  taxonomy?: Maybe<Scalars['String']>,
  parent?: Maybe<Scalars['Int']>,
  meta?: Maybe<Scalars['JSON']>,
};


export type CategoryPostsArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<PostWhereUniqueInput>
};

export type CategoryListRelationFilter = {
  every?: Maybe<CategoryWhereInput>,
  some?: Maybe<CategoryWhereInput>,
  none?: Maybe<CategoryWhereInput>,
};

export type CategoryOrderByInput = {
  id?: Maybe<SortOrder>,
  categoryId?: Maybe<SortOrder>,
  site?: Maybe<SiteOrderByInput>,
  siteId?: Maybe<SortOrder>,
  count?: Maybe<SortOrder>,
  description?: Maybe<SortOrder>,
  link?: Maybe<SortOrder>,
  name?: Maybe<SortOrder>,
  slug?: Maybe<SortOrder>,
  taxonomy?: Maybe<SortOrder>,
  parent?: Maybe<SortOrder>,
  meta?: Maybe<SortOrder>,
};

export type CategorySite_CategoryCompoundUniqueInput = {
  categoryId: Scalars['String'],
  siteId: Scalars['String'],
};

export type CategoryWhereInput = {
  AND?: Maybe<Array<CategoryWhereInput>>,
  OR?: Maybe<Array<CategoryWhereInput>>,
  NOT?: Maybe<Array<CategoryWhereInput>>,
  id?: Maybe<StringFilter>,
  categoryId?: Maybe<StringFilter>,
  posts?: Maybe<PostListRelationFilter>,
  site?: Maybe<SiteWhereInput>,
  siteId?: Maybe<StringFilter>,
  count?: Maybe<IntNullableFilter>,
  description?: Maybe<StringNullableFilter>,
  link?: Maybe<StringNullableFilter>,
  name?: Maybe<StringNullableFilter>,
  slug?: Maybe<StringNullableFilter>,
  taxonomy?: Maybe<StringNullableFilter>,
  parent?: Maybe<IntNullableFilter>,
  meta?: Maybe<StringNullableFilter>,
};

export type CategoryWhereUniqueInput = {
  id?: Maybe<Scalars['String']>,
  site_category?: Maybe<CategorySite_CategoryCompoundUniqueInput>,
};


export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>,
  in?: Maybe<Array<Scalars['DateTime']>>,
  notIn?: Maybe<Array<Scalars['DateTime']>>,
  lt?: Maybe<Scalars['DateTime']>,
  lte?: Maybe<Scalars['DateTime']>,
  gt?: Maybe<Scalars['DateTime']>,
  gte?: Maybe<Scalars['DateTime']>,
  not?: Maybe<NestedDateTimeNullableFilter>,
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>,
  in?: Maybe<Array<Scalars['Int']>>,
  notIn?: Maybe<Array<Scalars['Int']>>,
  lt?: Maybe<Scalars['Int']>,
  lte?: Maybe<Scalars['Int']>,
  gt?: Maybe<Scalars['Int']>,
  gte?: Maybe<Scalars['Int']>,
  not?: Maybe<NestedIntNullableFilter>,
};


export type MediaFile = {
   __typename?: 'MediaFile',
  id: Scalars['String'],
  mediaId: Scalars['String'],
  site: Site,
  date?: Maybe<Scalars['DateTime']>,
  modified?: Maybe<Scalars['DateTime']>,
  slug?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  link?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  caption?: Maybe<Scalars['String']>,
  sourceUrl?: Maybe<Scalars['String']>,
};

export type MediaFileListRelationFilter = {
  every?: Maybe<MediaFileWhereInput>,
  some?: Maybe<MediaFileWhereInput>,
  none?: Maybe<MediaFileWhereInput>,
};

export type MediaFileOrderByInput = {
  id?: Maybe<SortOrder>,
  mediaId?: Maybe<SortOrder>,
  site?: Maybe<SiteOrderByInput>,
  siteId?: Maybe<SortOrder>,
  date?: Maybe<SortOrder>,
  modified?: Maybe<SortOrder>,
  slug?: Maybe<SortOrder>,
  status?: Maybe<SortOrder>,
  type?: Maybe<SortOrder>,
  link?: Maybe<SortOrder>,
  title?: Maybe<SortOrder>,
  caption?: Maybe<SortOrder>,
  sourceUrl?: Maybe<SortOrder>,
};

export type MediaFileSite_MediaCompoundUniqueInput = {
  mediaId: Scalars['String'],
  siteId: Scalars['String'],
};

export type MediaFileWhereInput = {
  AND?: Maybe<Array<MediaFileWhereInput>>,
  OR?: Maybe<Array<MediaFileWhereInput>>,
  NOT?: Maybe<Array<MediaFileWhereInput>>,
  id?: Maybe<StringFilter>,
  mediaId?: Maybe<StringFilter>,
  site?: Maybe<SiteWhereInput>,
  siteId?: Maybe<StringFilter>,
  date?: Maybe<DateTimeNullableFilter>,
  modified?: Maybe<DateTimeNullableFilter>,
  slug?: Maybe<StringNullableFilter>,
  status?: Maybe<StringNullableFilter>,
  type?: Maybe<StringNullableFilter>,
  link?: Maybe<StringNullableFilter>,
  title?: Maybe<StringNullableFilter>,
  caption?: Maybe<StringNullableFilter>,
  sourceUrl?: Maybe<StringNullableFilter>,
  Post?: Maybe<PostListRelationFilter>,
};

export type MediaFileWhereUniqueInput = {
  id?: Maybe<Scalars['String']>,
  site_media?: Maybe<MediaFileSite_MediaCompoundUniqueInput>,
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>,
  not?: Maybe<NestedBoolFilter>,
};

export type NestedBoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>,
  not?: Maybe<NestedBoolNullableFilter>,
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>,
  in?: Maybe<Array<Scalars['DateTime']>>,
  notIn?: Maybe<Array<Scalars['DateTime']>>,
  lt?: Maybe<Scalars['DateTime']>,
  lte?: Maybe<Scalars['DateTime']>,
  gt?: Maybe<Scalars['DateTime']>,
  gte?: Maybe<Scalars['DateTime']>,
  not?: Maybe<NestedDateTimeNullableFilter>,
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars['Int']>,
  in?: Maybe<Array<Scalars['Int']>>,
  notIn?: Maybe<Array<Scalars['Int']>>,
  lt?: Maybe<Scalars['Int']>,
  lte?: Maybe<Scalars['Int']>,
  gt?: Maybe<Scalars['Int']>,
  gte?: Maybe<Scalars['Int']>,
  not?: Maybe<NestedIntNullableFilter>,
};

export type NestedStringFilter = {
  equals?: Maybe<Scalars['String']>,
  in?: Maybe<Array<Scalars['String']>>,
  notIn?: Maybe<Array<Scalars['String']>>,
  lt?: Maybe<Scalars['String']>,
  lte?: Maybe<Scalars['String']>,
  gt?: Maybe<Scalars['String']>,
  gte?: Maybe<Scalars['String']>,
  contains?: Maybe<Scalars['String']>,
  startsWith?: Maybe<Scalars['String']>,
  endsWith?: Maybe<Scalars['String']>,
  not?: Maybe<NestedStringFilter>,
};

export type NestedStringNullableFilter = {
  equals?: Maybe<Scalars['String']>,
  in?: Maybe<Array<Scalars['String']>>,
  notIn?: Maybe<Array<Scalars['String']>>,
  lt?: Maybe<Scalars['String']>,
  lte?: Maybe<Scalars['String']>,
  gt?: Maybe<Scalars['String']>,
  gte?: Maybe<Scalars['String']>,
  contains?: Maybe<Scalars['String']>,
  startsWith?: Maybe<Scalars['String']>,
  endsWith?: Maybe<Scalars['String']>,
  not?: Maybe<NestedStringNullableFilter>,
};

export type Post = {
   __typename?: 'Post',
  id: Scalars['String'],
  postId: Scalars['String'],
  site: Site,
  position?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['DateTime']>,
  title?: Maybe<Scalars['String']>,
  modified?: Maybe<Scalars['DateTime']>,
  slug?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  link?: Maybe<Scalars['String']>,
  excerpt?: Maybe<Scalars['String']>,
  analytics?: Maybe<Analytics>,
  featuredMedia?: Maybe<MediaFile>,
  sticky?: Maybe<Scalars['Boolean']>,
  categories: Array<Category>,
  tags: Array<Tag>,
  author?: Maybe<User>,
  isGutenberg?: Maybe<Scalars['Boolean']>,
  pinned: Scalars['Boolean'],
  customFields?: Maybe<Scalars['JSON']>,
  content?: Maybe<Scalars['JSON']>,
};


export type PostCategoriesArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<CategoryWhereUniqueInput>
};


export type PostTagsArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<TagWhereUniqueInput>
};

export type PostListRelationFilter = {
  every?: Maybe<PostWhereInput>,
  some?: Maybe<PostWhereInput>,
  none?: Maybe<PostWhereInput>,
};

export type PostOrderByInput = {
  id?: Maybe<SortOrder>,
  postId?: Maybe<SortOrder>,
  site?: Maybe<SiteOrderByInput>,
  siteId?: Maybe<SortOrder>,
  position?: Maybe<SortOrder>,
  date?: Maybe<SortOrder>,
  title?: Maybe<SortOrder>,
  modified?: Maybe<SortOrder>,
  slug?: Maybe<SortOrder>,
  status?: Maybe<SortOrder>,
  type?: Maybe<SortOrder>,
  link?: Maybe<SortOrder>,
  excerpt?: Maybe<SortOrder>,
  analytics?: Maybe<AnalyticsOrderByInput>,
  analyticsId?: Maybe<SortOrder>,
  featuredMedia?: Maybe<MediaFileOrderByInput>,
  featuredMediaId?: Maybe<SortOrder>,
  sticky?: Maybe<SortOrder>,
  author?: Maybe<UserOrderByInput>,
  authorId?: Maybe<SortOrder>,
  isGutenberg?: Maybe<SortOrder>,
  pinned?: Maybe<SortOrder>,
  content?: Maybe<SortOrder>,
  customFields?: Maybe<SortOrder>,
};

export type PostSite_PostCompoundUniqueInput = {
  postId: Scalars['String'],
  siteId: Scalars['String'],
};

export type PostWhereInput = {
  AND?: Maybe<Array<PostWhereInput>>,
  OR?: Maybe<Array<PostWhereInput>>,
  NOT?: Maybe<Array<PostWhereInput>>,
  id?: Maybe<StringFilter>,
  postId?: Maybe<StringFilter>,
  site?: Maybe<SiteWhereInput>,
  siteId?: Maybe<StringFilter>,
  position?: Maybe<IntNullableFilter>,
  date?: Maybe<DateTimeNullableFilter>,
  title?: Maybe<StringNullableFilter>,
  modified?: Maybe<DateTimeNullableFilter>,
  slug?: Maybe<StringNullableFilter>,
  status?: Maybe<StringNullableFilter>,
  type?: Maybe<StringNullableFilter>,
  link?: Maybe<StringNullableFilter>,
  excerpt?: Maybe<StringNullableFilter>,
  analytics?: Maybe<AnalyticsWhereInput>,
  analyticsId?: Maybe<StringNullableFilter>,
  featuredMedia?: Maybe<MediaFileWhereInput>,
  featuredMediaId?: Maybe<StringNullableFilter>,
  sticky?: Maybe<BoolNullableFilter>,
  categories?: Maybe<CategoryListRelationFilter>,
  tags?: Maybe<TagListRelationFilter>,
  author?: Maybe<UserWhereInput>,
  authorId?: Maybe<StringNullableFilter>,
  isGutenberg?: Maybe<BoolNullableFilter>,
  pinned?: Maybe<BoolFilter>,
  content?: Maybe<StringNullableFilter>,
  customFields?: Maybe<StringNullableFilter>,
};

export type PostWhereUniqueInput = {
  id?: Maybe<Scalars['String']>,
  site_post?: Maybe<PostSite_PostCompoundUniqueInput>,
};

export type Query = {
   __typename?: 'Query',
  user?: Maybe<User>,
  users: Array<User>,
  post?: Maybe<Post>,
  posts: Array<Post>,
  site?: Maybe<Site>,
  sites: Array<Site>,
  mediaFile?: Maybe<MediaFile>,
  mediaFiles: Array<MediaFile>,
  category?: Maybe<Category>,
  categories: Array<Category>,
  tag?: Maybe<Tag>,
  tags: Array<Tag>,
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput
};


export type QueryUsersArgs = {
  where?: Maybe<UserWhereInput>,
  orderBy?: Maybe<Array<UserOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<UserWhereUniqueInput>
};


export type QueryPostArgs = {
  where: PostWhereUniqueInput
};


export type QueryPostsArgs = {
  where?: Maybe<PostWhereInput>,
  orderBy?: Maybe<Array<PostOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<PostWhereUniqueInput>
};


export type QuerySiteArgs = {
  where: SiteWhereUniqueInput
};


export type QuerySitesArgs = {
  where?: Maybe<SiteWhereInput>,
  orderBy?: Maybe<Array<SiteOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<SiteWhereUniqueInput>
};


export type QueryMediaFileArgs = {
  where: MediaFileWhereUniqueInput
};


export type QueryMediaFilesArgs = {
  where?: Maybe<MediaFileWhereInput>,
  orderBy?: Maybe<Array<MediaFileOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<MediaFileWhereUniqueInput>
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput
};


export type QueryCategoriesArgs = {
  where?: Maybe<CategoryWhereInput>,
  orderBy?: Maybe<Array<CategoryOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<CategoryWhereUniqueInput>
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput
};


export type QueryTagsArgs = {
  where?: Maybe<TagWhereInput>,
  orderBy?: Maybe<Array<TagOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<TagWhereUniqueInput>
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Site = {
   __typename?: 'Site',
  id: Scalars['String'],
  name: Scalars['String'],
  url: Scalars['String'],
  restEndpoint: Scalars['String'],
  colors?: Maybe<SiteColors>,
  posts: Array<Post>,
  categories: Array<Category>,
  tags: Array<Tag>,
  mediaFiles: Array<MediaFile>,
  users: Array<User>,
  language?: Maybe<Scalars['String']>,
};


export type SitePostsArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<PostWhereUniqueInput>
};


export type SiteCategoriesArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<CategoryWhereUniqueInput>
};


export type SiteTagsArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<TagWhereUniqueInput>
};


export type SiteMediaFilesArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<MediaFileWhereUniqueInput>
};


export type SiteUsersArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<UserWhereUniqueInput>
};

export type SiteColors = {
   __typename?: 'SiteColors',
  id: Scalars['String'],
  primary?: Maybe<Scalars['String']>,
  secondary?: Maybe<Scalars['String']>,
};

export type SiteColorsOrderByInput = {
  id?: Maybe<SortOrder>,
  primary?: Maybe<SortOrder>,
  secondary?: Maybe<SortOrder>,
};

export type SiteColorsWhereInput = {
  AND?: Maybe<Array<SiteColorsWhereInput>>,
  OR?: Maybe<Array<SiteColorsWhereInput>>,
  NOT?: Maybe<Array<SiteColorsWhereInput>>,
  id?: Maybe<StringFilter>,
  primary?: Maybe<StringNullableFilter>,
  secondary?: Maybe<StringNullableFilter>,
  Site?: Maybe<SiteListRelationFilter>,
};

export type SiteListRelationFilter = {
  every?: Maybe<SiteWhereInput>,
  some?: Maybe<SiteWhereInput>,
  none?: Maybe<SiteWhereInput>,
};

export type SiteOrderByInput = {
  id?: Maybe<SortOrder>,
  name?: Maybe<SortOrder>,
  url?: Maybe<SortOrder>,
  restEndpoint?: Maybe<SortOrder>,
  colors?: Maybe<SiteColorsOrderByInput>,
  colorsId?: Maybe<SortOrder>,
  language?: Maybe<SortOrder>,
};

export type SiteWhereInput = {
  AND?: Maybe<Array<SiteWhereInput>>,
  OR?: Maybe<Array<SiteWhereInput>>,
  NOT?: Maybe<Array<SiteWhereInput>>,
  id?: Maybe<StringFilter>,
  name?: Maybe<StringFilter>,
  url?: Maybe<StringFilter>,
  restEndpoint?: Maybe<StringFilter>,
  colors?: Maybe<SiteColorsWhereInput>,
  colorsId?: Maybe<StringNullableFilter>,
  posts?: Maybe<PostListRelationFilter>,
  categories?: Maybe<CategoryListRelationFilter>,
  tags?: Maybe<TagListRelationFilter>,
  mediaFiles?: Maybe<MediaFileListRelationFilter>,
  users?: Maybe<UserListRelationFilter>,
  language?: Maybe<StringNullableFilter>,
};

export type SiteWhereUniqueInput = {
  id?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilter = {
  equals?: Maybe<Scalars['String']>,
  in?: Maybe<Array<Scalars['String']>>,
  notIn?: Maybe<Array<Scalars['String']>>,
  lt?: Maybe<Scalars['String']>,
  lte?: Maybe<Scalars['String']>,
  gt?: Maybe<Scalars['String']>,
  gte?: Maybe<Scalars['String']>,
  contains?: Maybe<Scalars['String']>,
  startsWith?: Maybe<Scalars['String']>,
  endsWith?: Maybe<Scalars['String']>,
  mode?: Maybe<QueryMode>,
  not?: Maybe<NestedStringFilter>,
};

export type StringNullableFilter = {
  equals?: Maybe<Scalars['String']>,
  in?: Maybe<Array<Scalars['String']>>,
  notIn?: Maybe<Array<Scalars['String']>>,
  lt?: Maybe<Scalars['String']>,
  lte?: Maybe<Scalars['String']>,
  gt?: Maybe<Scalars['String']>,
  gte?: Maybe<Scalars['String']>,
  contains?: Maybe<Scalars['String']>,
  startsWith?: Maybe<Scalars['String']>,
  endsWith?: Maybe<Scalars['String']>,
  mode?: Maybe<QueryMode>,
  not?: Maybe<NestedStringNullableFilter>,
};

export type Tag = {
   __typename?: 'Tag',
  id: Scalars['String'],
  tagId: Scalars['String'],
  posts: Array<Post>,
  site: Site,
  count?: Maybe<Scalars['Int']>,
  description?: Maybe<Scalars['String']>,
  link?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  slug?: Maybe<Scalars['String']>,
  taxonomy?: Maybe<Scalars['String']>,
  meta?: Maybe<Scalars['JSON']>,
};


export type TagPostsArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<PostWhereUniqueInput>
};

export type TagListRelationFilter = {
  every?: Maybe<TagWhereInput>,
  some?: Maybe<TagWhereInput>,
  none?: Maybe<TagWhereInput>,
};

export type TagOrderByInput = {
  id?: Maybe<SortOrder>,
  tagId?: Maybe<SortOrder>,
  site?: Maybe<SiteOrderByInput>,
  siteId?: Maybe<SortOrder>,
  count?: Maybe<SortOrder>,
  description?: Maybe<SortOrder>,
  link?: Maybe<SortOrder>,
  name?: Maybe<SortOrder>,
  slug?: Maybe<SortOrder>,
  taxonomy?: Maybe<SortOrder>,
  meta?: Maybe<SortOrder>,
};

export type TagSite_TagCompoundUniqueInput = {
  tagId: Scalars['String'],
  siteId: Scalars['String'],
};

export type TagWhereInput = {
  AND?: Maybe<Array<TagWhereInput>>,
  OR?: Maybe<Array<TagWhereInput>>,
  NOT?: Maybe<Array<TagWhereInput>>,
  id?: Maybe<StringFilter>,
  tagId?: Maybe<StringFilter>,
  posts?: Maybe<PostListRelationFilter>,
  site?: Maybe<SiteWhereInput>,
  siteId?: Maybe<StringFilter>,
  count?: Maybe<IntNullableFilter>,
  description?: Maybe<StringNullableFilter>,
  link?: Maybe<StringNullableFilter>,
  name?: Maybe<StringNullableFilter>,
  slug?: Maybe<StringNullableFilter>,
  taxonomy?: Maybe<StringNullableFilter>,
  meta?: Maybe<StringNullableFilter>,
};

export type TagWhereUniqueInput = {
  id?: Maybe<Scalars['String']>,
  site_tag?: Maybe<TagSite_TagCompoundUniqueInput>,
};

export type User = {
   __typename?: 'User',
  id: Scalars['String'],
  userId: Scalars['String'],
  posts: Array<Post>,
  site: Site,
  description?: Maybe<Scalars['String']>,
  link?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  slug?: Maybe<Scalars['String']>,
  taxonomy?: Maybe<Scalars['String']>,
  meta?: Maybe<Scalars['JSON']>,
  avatarUrls?: Maybe<Scalars['JSON']>,
};


export type UserPostsArgs = {
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>,
  cursor?: Maybe<PostWhereUniqueInput>
};

export type UserListRelationFilter = {
  every?: Maybe<UserWhereInput>,
  some?: Maybe<UserWhereInput>,
  none?: Maybe<UserWhereInput>,
};

export type UserOrderByInput = {
  id?: Maybe<SortOrder>,
  userId?: Maybe<SortOrder>,
  site?: Maybe<SiteOrderByInput>,
  siteId?: Maybe<SortOrder>,
  description?: Maybe<SortOrder>,
  link?: Maybe<SortOrder>,
  name?: Maybe<SortOrder>,
  slug?: Maybe<SortOrder>,
  taxonomy?: Maybe<SortOrder>,
  meta?: Maybe<SortOrder>,
  avatarUrls?: Maybe<SortOrder>,
};

export type UserSite_UserCompoundUniqueInput = {
  userId: Scalars['String'],
  siteId: Scalars['String'],
};

export type UserWhereInput = {
  AND?: Maybe<Array<UserWhereInput>>,
  OR?: Maybe<Array<UserWhereInput>>,
  NOT?: Maybe<Array<UserWhereInput>>,
  id?: Maybe<StringFilter>,
  userId?: Maybe<StringFilter>,
  posts?: Maybe<PostListRelationFilter>,
  site?: Maybe<SiteWhereInput>,
  siteId?: Maybe<StringFilter>,
  description?: Maybe<StringNullableFilter>,
  link?: Maybe<StringNullableFilter>,
  name?: Maybe<StringNullableFilter>,
  slug?: Maybe<StringNullableFilter>,
  taxonomy?: Maybe<StringNullableFilter>,
  meta?: Maybe<StringNullableFilter>,
  avatarUrls?: Maybe<StringNullableFilter>,
};

export type UserWhereUniqueInput = {
  id?: Maybe<Scalars['String']>,
  site_user?: Maybe<UserSite_UserCompoundUniqueInput>,
};

export type PostsQueryVariables = {
  where?: Maybe<PostWhereInput>,
  orderBy?: Maybe<Array<PostOrderByInput>>,
  take?: Maybe<Scalars['Int']>,
  skip?: Maybe<Scalars['Int']>
};


export type PostsQuery = (
  { __typename?: 'Query' }
  & { posts: Array<(
    { __typename?: 'Post' }
    & Pick<Post, 'title' | 'excerpt' | 'link' | 'position'>
    & { featuredMedia: Maybe<(
      { __typename?: 'MediaFile' }
      & Pick<MediaFile, 'sourceUrl'>
    )>, site: (
      { __typename?: 'Site' }
      & Pick<Site, 'url'>
      & { colors: Maybe<(
        { __typename?: 'SiteColors' }
        & Pick<SiteColors, 'primary' | 'secondary'>
      )> }
    ) }
  )> }
);


export const PostsDocument = gql`
    query Posts($where: PostWhereInput, $orderBy: [PostOrderByInput!], $take: Int, $skip: Int) {
  posts(where: $where, take: $take, orderBy: $orderBy, skip: $skip) {
    title
    excerpt
    link
    position
    featuredMedia {
      sourceUrl
    }
    site {
      url
      colors {
        primary
        secondary
      }
    }
  }
}
    `;
export type PostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PostsQuery, PostsQueryVariables>, 'query'>;

    export const PostsComponent = (props: PostsComponentProps) => (
      <ApolloReactComponents.Query<PostsQuery, PostsQueryVariables> query={PostsDocument} {...props} />
    );
    

/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PostsQuery, PostsQueryVariables>) {
        return ApolloReactHooks.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, baseOptions);
      }
export function usePostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, baseOptions);
        }
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsQueryResult = ApolloReactCommon.QueryResult<PostsQuery, PostsQueryVariables>;